<div class="loader"></div>
<div class="loader"></div>
<div class="loader"></div>
